import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISearchItem } from 'bi-interfaces';

@Component({
  selector: 'sidebar-search-results',
  templateUrl: './sidebar-search-results.component.html',
  styleUrls: ['./sidebar-search-results.component.scss']
})
export class SidebarSearchResultsComponent {
  @Output() routeNavigated = new EventEmitter();

  @Input() searchResults: ISearchItem[] = [];
  @Input() searchValue: string = '';
  @Input() contentView: 'mainMenu' | 'subMenu' = 'mainMenu';

  constructor() {}

  public navigateToScreen(item: any) {
    this.routeNavigated.emit({...item});
  }
}